// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty {
  padding: 56px 24px;
  text-align: center;
  border: 1px dashed var(--border);
  border-radius: var(--r-data);
  background: var(--bg-alt);
}

.empty--dark {
  border-color: var(--ink-rule);
  background: var(--ink-dark-2);
}

.empty__symbol {
  font-family: var(--display);
  font-size: 36px;
  color: var(--cream-deep);
  line-height: 1;
  margin-bottom: 12px;
}

.empty--dark .empty__symbol {
  color: var(--cream);
}

.empty__title {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-prose);
  margin: 0 0 6px;
  color: var(--text);
  letter-spacing: -0.005em;
}

.empty--dark .empty__title {
  color: var(--ink-text);
}

.empty__body {
  margin: 0 0 16px;
  color: var(--text-muted);
  font-size: var(--fs-ui);
}

.empty--dark .empty__body {
  color: var(--ink-text-3);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Empty/Empty.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".empty {\n  padding: 56px 24px;\n  text-align: center;\n  border: 1px dashed var(--border);\n  border-radius: var(--r-data);\n  background: var(--bg-alt);\n}\n\n.empty--dark {\n  border-color: var(--ink-rule);\n  background: var(--ink-dark-2);\n}\n\n.empty__symbol {\n  font-family: var(--display);\n  font-size: 36px;\n  color: var(--cream-deep);\n  line-height: 1;\n  margin-bottom: 12px;\n}\n\n.empty--dark .empty__symbol {\n  color: var(--cream);\n}\n\n.empty__title {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-prose);\n  margin: 0 0 6px;\n  color: var(--text);\n  letter-spacing: -0.005em;\n}\n\n.empty--dark .empty__title {\n  color: var(--ink-text);\n}\n\n.empty__body {\n  margin: 0 0 16px;\n  color: var(--text-muted);\n  font-size: var(--fs-ui);\n}\n\n.empty--dark .empty__body {\n  color: var(--ink-text-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
